// pages/AppCreatedSuccess.js
import React, { useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import Navbar from '../components/Navbar';

function AppCreatedSuccess() {
  const { state: locationState } = useLocation();
  const navigate = useNavigate();
  const { dispatch } = useApp();

  // Bloquear o botão voltar do navegador
  useEffect(() => {
    const handleBackButton = (e) => {
      e.preventDefault();
      window.history.forward();
    };

    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);

  const handleGoToDashboard = useCallback(() => {
    // Limpar o estado do app builder
    dispatch({ type: 'RESET_APP_DATA' });
    
    // Navegar para o dashboard com replace para não poder voltar
    navigate('/dashboard', { 
      replace: true,
      state: { 
        message: locationState?.message || 'Aplicativo criado com sucesso!',
        appId: locationState?.appId
      }
    });
  }, [dispatch, navigate, locationState]);

  // Redirecionar automaticamente após 3 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      handleGoToDashboard();
    }, 3000);

    return () => clearTimeout(timer);
  }, [handleGoToDashboard]); // ✅ Now includes the dependency

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="bg-white rounded-xl shadow-sm p-8 text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
            <svg className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            App Criado com Sucesso!
          </h1>
          
          <p className="text-gray-600 mb-6">
            Seu aplicativo foi criado e está em processamento. 
            Você será redirecionado para o dashboard em instantes...
          </p>

          {locationState?.appId && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <p className="text-sm text-gray-600">ID do Aplicativo:</p>
              <p className="text-sm font-mono text-gray-800 break-all">{locationState.appId}</p>
            </div>
          )}

          <button
            onClick={handleGoToDashboard}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 transition-colors"
          >
            Ir para o Dashboard Agora
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppCreatedSuccess;